import axiosInstance, { getApiUrl, ApiKeys, logError } from '@cp/src/utils/ApiHelper';
import { ImpersonationPayload } from './interface';

export const impersonateUser = async (payload: ImpersonationPayload) => {
  const url = getApiUrl(ApiKeys.IMPERSONATION);
  try {
    const response = await axiosInstance.post(url, payload);
    if (response?.data) {
      return {
        data: {
          accessToken: response.data.accessToken,
          expiryTime: response.data.expiryTime
        }
      };
    }
    logError('Invalid response format');
  } catch (error: any) {
    logError(error?.response?.data?.message || 'Failed to impersonate user');
  }
};
